import { InstanceOf, Number, Partial, Record, String } from "runtypes";
export const ShareableWatched = Record({
  id: String,
  timestamp: Number
}).And(
  Partial({
    duration: Number,
    playbackRate: Number
  })
);
export const SavedShareableWatched = Record({
  id: String,
  netID: String,
  timestamp: InstanceOf(Date),
  watched: ShareableWatched
}).And(
  Partial({
    version: Number,
    semester: String
  })
);
//# sourceMappingURL=watched.js.map
